import axios from 'axios'
import Cookie from 'js-cookie'

/**
 * Returns a fresh crsf token
 */
export const refreshCrsf = async (): Promise<string> => {
  if (!Cookie.get('_csrf')) {
    await axios.get('/session', { withCredentials: true })
  }
  const csrfResponse = await axios.get('/token', { withCredentials: true })

  return await csrfResponse.data
}
